import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { selectIsCloudRecordingAvailable } from '../../../../../../pages/call/features/cloud-recording';
import {
    selectHasCloudRecordingBanRolePermission,
    selectHasMembersCloudRecordingPermission,
    setCloudRecordingForMembersAllowed,
} from '../../../../../../pages/call/features/permissions';
import { Switch } from '../../../../../components';
import { i18n } from '../../../../../helpers/i18n';
import { useOnPermissionChange } from '../../../hooks/use-on-permission-change';
import styles from './styles.css';

export const CloudRecordingSwitcher: FunctionComponent = () => {
    const isCloudRecordingAvailable = useSelector(selectIsCloudRecordingAvailable);
    const hasBanPermission = useSelector(selectHasCloudRecordingBanRolePermission);
    const hasMembersPermission = useSelector(selectHasMembersCloudRecordingPermission);

    const onChange = useOnPermissionChange(setCloudRecordingForMembersAllowed, 'cloud-recording');

    if (!isCloudRecordingAvailable || !hasBanPermission) {
        return null;
    }

    return (
        <Switch
            className={styles.switch}
            labelAfter={i18n('settings', 'permission-ban-cloud-recording')}
            checked={hasMembersPermission}
            onChange={onChange}
            size="sm"
            stretch
            shrink
        />
    );
};
